"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[858],{

/***/ 5858:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Authentication; },
/* harmony export */   "forgotPasswordPage": function() { return /* binding */ forgotPasswordPage; },
/* harmony export */   "homePage": function() { return /* binding */ homePage; },
/* harmony export */   "signInPage": function() { return /* binding */ signInPage; },
/* harmony export */   "signUpPage": function() { return /* binding */ signUpPage; },
/* harmony export */   "treasuredLogoImg": function() { return /* binding */ treasuredLogoImg; },
/* harmony export */   "userDetailsPage": function() { return /* binding */ userDetailsPage; },
/* harmony export */   "userSettingsPage": function() { return /* binding */ userSettingsPage; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(3842);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5230);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4246);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7378);
/* harmony import */ var _utils_accountService_accountManager__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8608);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6677);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);






var signUpPage = "/account/user/signUp";
var signInPage = "/account/user/signIn";
var forgotPasswordPage = "/account/user/forgot-password";
var userDetailsPage = "/account/user/userDetails";
var userSettingsPage = "/account/user/userSettings";
var homePage = "/account";
var treasuredLogoImg = "https://accounts.treasured.ca/resources/0tmtg/login/treasured/img/logo.png";
function Authentication() {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        GetAccountStatus();
    }, []);
    function GetAccountStatus() {
        return _GetAccountStatus.apply(this, arguments);
    }
    function _GetAccountStatus() {
        _GetAccountStatus = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var response;
            return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return _utils_accountService_accountManager__WEBPACK_IMPORTED_MODULE_3__/* ["default"].GetSession */ .Z.GetSession();
                    case 2:
                        response = _ctx.sent;
                        if (response.status == _utils_accountService_accountManager__WEBPACK_IMPORTED_MODULE_3__/* .AccountResponseStatus.SUCCESS */ .j.SUCCESS) {
                            router.push(userDetailsPage);
                        } else {
                            router.push(signInPage);
                        }
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return _GetAccountStatus.apply(this, arguments);
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
        children: "Loading..."
    });
};


/***/ }),

/***/ 8608:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ AccountResponseStatus; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3842);
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4364);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1151);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5230);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _supabase_supabase_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8507);





var supabase = (0,_supabase_supabase_js__WEBPACK_IMPORTED_MODULE_1__/* .createClient */ .eI)("https://djaynsjblwtihpepshgd.supabase.co", "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImRqYXluc2pibHd0aWhwZXBzaGdkIiwicm9sZSI6ImFub24iLCJpYXQiOjE2NzkxNTY5NTEsImV4cCI6MTk5NDczMjk1MX0.XsLzvbcY8EHePMal20Mj70JA6BvJ2YnYBOrYPcNqUO0");
var accountManager = /*#__PURE__*/ function() {
    "use strict";
    function accountManager() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(this, accountManager);
    }
    accountManager.SignIn = function SignIn(email, password) {
        return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var ref, user, _$error;
            return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return supabase.auth.signInWithPassword({
                            email: email,
                            password: password
                        });
                    case 3:
                        ref = _ctx.sent;
                        user = ref.data;
                        _$error = ref.error;
                        if (!_$error) {
                            _ctx.next = 10;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            status: AccountResponseStatus.FAILURE,
                            message: _$error.message
                        });
                    case 10:
                        return _ctx.abrupt("return", {
                            status: AccountResponseStatus.SUCCESS,
                            message: "Sign in successful.",
                            data: user
                        });
                    case 11:
                        _ctx.next = 16;
                        break;
                    case 13:
                        _ctx.prev = 13;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", {
                            status: AccountResponseStatus.FAILURE,
                            message: _ctx.t0.message
                        });
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    13
                ]
            ]);
        }))();
    };
    accountManager.SignOut = function SignOut() {
        return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var _$error;
            return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return supabase.auth.signOut();
                    case 3:
                        _$error = _ctx.sent.error;
                        if (!_$error) {
                            _ctx.next = 8;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            status: AccountResponseStatus.FAILURE,
                            message: _$error.message
                        });
                    case 8:
                        return _ctx.abrupt("return", {
                            status: AccountResponseStatus.SUCCESS,
                            message: "Sign out successful."
                        });
                    case 9:
                        _ctx.next = 14;
                        break;
                    case 11:
                        _ctx.prev = 11;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", {
                            status: AccountResponseStatus.FAILURE,
                            message: _ctx.t0.message
                        });
                    case 14:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    11
                ]
            ]);
        }))();
    };
    accountManager.SignUp = function SignUp(email, password) {
        return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var ref, user, _$error;
            return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return supabase.auth.signUp({
                            email: email,
                            password: password
                        });
                    case 3:
                        ref = _ctx.sent;
                        user = ref.data;
                        _$error = ref.error;
                        if (!_$error) {
                            _ctx.next = 10;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            status: AccountResponseStatus.FAILURE,
                            message: _$error.message
                        });
                    case 10:
                        return _ctx.abrupt("return", {
                            status: AccountResponseStatus.SUCCESS,
                            message: "Sign up successful.",
                            data: user
                        });
                    case 11:
                        _ctx.next = 16;
                        break;
                    case 13:
                        _ctx.prev = 13;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", {
                            status: AccountResponseStatus.FAILURE,
                            message: _ctx.t0.message
                        });
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    13
                ]
            ]);
        }))();
    };
    accountManager.ForgotPassword = function ForgotPassword(email) {
        return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var ref, user, _$error;
            return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return supabase.auth.resetPasswordForEmail(email, {
                            redirectTo: "http://localhost:3000/account/user/resetPassword/"
                        });
                    case 3:
                        ref = _ctx.sent;
                        user = ref.data;
                        _$error = ref.error;
                        if (!_$error) {
                            _ctx.next = 10;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            status: AccountResponseStatus.FAILURE,
                            message: _$error.message
                        });
                    case 10:
                        return _ctx.abrupt("return", {
                            status: AccountResponseStatus.SUCCESS,
                            message: "If you registered using your email and password, you will receive a password reset email.",
                            data: user
                        });
                    case 11:
                        _ctx.next = 16;
                        break;
                    case 13:
                        _ctx.prev = 13;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", {
                            status: AccountResponseStatus.FAILURE,
                            message: _ctx.t0.message
                        });
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    13
                ]
            ]);
        }))();
    };
    accountManager.ResetPassword = function ResetPassword(password) {
        return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var ref, resetPasswordData, _$error;
            return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return supabase.auth.updateUser({
                            password: password
                        });
                    case 3:
                        ref = _ctx.sent;
                        resetPasswordData = ref.data;
                        _$error = ref.error;
                        if (!_$error) {
                            _ctx.next = 10;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            status: AccountResponseStatus.FAILURE,
                            message: _$error.message
                        });
                    case 10:
                        return _ctx.abrupt("return", {
                            status: AccountResponseStatus.SUCCESS,
                            message: "Password reset successful.",
                            data: resetPasswordData
                        });
                    case 11:
                        _ctx.next = 16;
                        break;
                    case 13:
                        _ctx.prev = 13;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", {
                            status: AccountResponseStatus.FAILURE,
                            message: _ctx.t0.message
                        });
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    13
                ]
            ]);
        }))();
    };
    accountManager.UpdateEmail = function UpdateEmail(email) {
        return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var ref, updateEmailData, _$error;
            return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return supabase.auth.updateUser({
                            email: email
                        });
                    case 3:
                        ref = _ctx.sent;
                        updateEmailData = ref.data;
                        _$error = ref.error;
                        if (!_$error) {
                            _ctx.next = 10;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            status: AccountResponseStatus.FAILURE,
                            message: _$error.message
                        });
                    case 10:
                        return _ctx.abrupt("return", {
                            status: AccountResponseStatus.SUCCESS,
                            message: "Email update request successful. \nPlease confirm your new email.",
                            data: updateEmailData
                        });
                    case 11:
                        _ctx.next = 16;
                        break;
                    case 13:
                        _ctx.prev = 13;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", {
                            status: AccountResponseStatus.FAILURE,
                            message: _ctx.t0.message
                        });
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    13
                ]
            ]);
        }))();
    };
    accountManager.GetSession = function GetSession() {
        var _this = this;
        return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var ref, user, _$error, userData;
            return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return supabase.auth.getSession();
                    case 3:
                        ref = _ctx.sent;
                        user = ref.data;
                        _$error = ref.error;
                        if (!user.session) {
                            _ctx.next = 13;
                            break;
                        }
                        userData = user.session.user;
                        _this.userEmail = userData.email;
                        _this.userUuid = userData.id;
                        return _ctx.abrupt("return", {
                            status: AccountResponseStatus.SUCCESS,
                            message: "User session found.",
                            data: user
                        });
                    case 13:
                        return _ctx.abrupt("return", {
                            status: AccountResponseStatus.FAILURE,
                            message: "Please Sign-in."
                        });
                    case 14:
                        _ctx.next = 19;
                        break;
                    case 16:
                        _ctx.prev = 16;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", {
                            status: AccountResponseStatus.FAILURE,
                            message: _ctx.t0.message
                        });
                    case 19:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    16
                ]
            ]);
        }))();
    };
    accountManager.GetUser = function GetUser() {
        var _this = this;
        return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var ref, userData, _$error;
            return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return supabase.from("users").select().eq("user_id", _this.userUuid);
                    case 3:
                        ref = _ctx.sent;
                        userData = ref.data;
                        _$error = ref.error;
                        if (!userData) {
                            _ctx.next = 12;
                            break;
                        }
                        _this.userName = userData[0].name;
                        _this.userAvatar = userData[0].avatar_url;
                        return _ctx.abrupt("return", {
                            status: AccountResponseStatus.SUCCESS,
                            message: "Found user details.",
                            data: userData
                        });
                    case 12:
                        return _ctx.abrupt("return", {
                            status: AccountResponseStatus.FAILURE,
                            message: _$error.message
                        });
                    case 13:
                        _ctx.next = 18;
                        break;
                    case 15:
                        _ctx.prev = 15;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", {
                            status: AccountResponseStatus.FAILURE,
                            message: _ctx.t0.message
                        });
                    case 18:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    15
                ]
            ]);
        }))();
    };
    accountManager.GetPublicUrl = function GetPublicUrl(filePath) {
        return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var uploadedImageURL;
            return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        uploadedImageURL = supabase.storage.from("exports").getPublicUrl("".concat(filePath, "?t=").concat(Date.now()));
                        if (uploadedImageURL) {
                            _ctx.next = 6;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            status: AccountResponseStatus.FAILURE,
                            message: "Failed to fetch ".concat(filePath)
                        });
                    case 6:
                        return _ctx.abrupt("return", {
                            status: AccountResponseStatus.SUCCESS,
                            message: "Fetched ".concat(filePath, " url."),
                            data: uploadedImageURL.data.publicUrl
                        });
                    case 7:
                        _ctx.next = 12;
                        break;
                    case 9:
                        _ctx.prev = 9;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", {
                            status: AccountResponseStatus.FAILURE,
                            message: _ctx.t0.message
                        });
                    case 12:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    9
                ]
            ]);
        }))();
    };
    accountManager.UpdateUserName = function UpdateUserName(newName) {
        var _this = this;
        return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var ref, userData, _$error;
            return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return supabase.from("users").update({
                            name: newName
                        }).eq("user_id", _this.userUuid);
                    case 3:
                        ref = _ctx.sent;
                        userData = ref.data;
                        _$error = ref.error;
                        if (userData) {
                            _ctx.next = 10;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            status: AccountResponseStatus.SUCCESS,
                            message: "Updated user details."
                        });
                    case 10:
                        return _ctx.abrupt("return", {
                            status: AccountResponseStatus.FAILURE,
                            message: _$error.message,
                            data: userData
                        });
                    case 11:
                        _ctx.next = 16;
                        break;
                    case 13:
                        _ctx.prev = 13;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", {
                            status: AccountResponseStatus.FAILURE,
                            message: _ctx.t0.message
                        });
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    13
                ]
            ]);
        }))();
    };
    accountManager.SetUserAvatar = function SetUserAvatar(file) {
        var _this = this;
        return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var ref, data, _$error, uploadedImageName, uploadedImageURL, ref1, injectAvatarUrlError;
            return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return supabase.storage.from("users").upload("".concat(_this.userUuid, "/user-avatar-").concat(_this.userUuid), file, {
                            upsert: true,
                            cacheControl: "no-cache"
                        });
                    case 3:
                        ref = _ctx.sent;
                        data = ref.data;
                        _$error = ref.error;
                        if (!data) {
                            _ctx.next = 20;
                            break;
                        }
                        uploadedImageName = data.path;
                        uploadedImageURL = supabase.storage.from("users").getPublicUrl(uploadedImageName);
                        _ctx.next = 11;
                        return supabase.from("users").update({
                            avatar_url: uploadedImageURL.data.publicUrl
                        }).eq("user_id", _this.userUuid);
                    case 11:
                        ref1 = _ctx.sent;
                        injectAvatarUrlError = ref1.error;
                        if (!injectAvatarUrlError) {
                            _ctx.next = 17;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            status: AccountResponseStatus.FAILURE,
                            message: _$error.message
                        });
                    case 17:
                        return _ctx.abrupt("return", {
                            status: AccountResponseStatus.SUCCESS,
                            message: "Updated Profile Image."
                        });
                    case 18:
                        _ctx.next = 21;
                        break;
                    case 20:
                        return _ctx.abrupt("return", {
                            status: AccountResponseStatus.FAILURE,
                            message: _$error.message
                        });
                    case 21:
                        _ctx.next = 26;
                        break;
                    case 23:
                        _ctx.prev = 23;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", {
                            status: AccountResponseStatus.FAILURE,
                            message: _ctx.t0.message
                        });
                    case 26:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    23
                ]
            ]);
        }))();
    };
    accountManager.GetProjects = function GetProjects() {
        return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var ref, projects, _$error;
            return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return supabase.from("projects").select("name, slug, user_id, users (name)");
                    case 3:
                        ref = _ctx.sent;
                        projects = ref.data;
                        _$error = ref.error;
                        if (!_$error) {
                            _ctx.next = 10;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            status: AccountResponseStatus.FAILURE,
                            message: _$error.message
                        });
                    case 10:
                        return _ctx.abrupt("return", {
                            status: AccountResponseStatus.SUCCESS,
                            message: "Fetched projects successfully.",
                            data: projects
                        });
                    case 11:
                        _ctx.next = 16;
                        break;
                    case 13:
                        _ctx.prev = 13;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", {
                            status: AccountResponseStatus.FAILURE,
                            message: _ctx.t0.message
                        });
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    13
                ]
            ]);
        }))();
    };
    accountManager.CreateProject = function CreateProject(param) {
        var projectName = param.projectName, slug = param.slug;
        var _this = this;
        return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var ref, project, _$error;
            return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return supabase.from("projects").insert({
                            name: projectName,
                            slug: slug,
                            owner: _this.userEmail,
                            user_id: _this.userUuid
                        }).select();
                    case 3:
                        ref = _ctx.sent;
                        project = ref.data;
                        _$error = ref.error;
                        if (!_$error) {
                            _ctx.next = 10;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            status: AccountResponseStatus.FAILURE,
                            message: _$error.message
                        });
                    case 10:
                        return _ctx.abrupt("return", {
                            status: AccountResponseStatus.SUCCESS,
                            message: "Created new project successfully.",
                            data: project
                        });
                    case 11:
                        _ctx.next = 16;
                        break;
                    case 13:
                        _ctx.prev = 13;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", {
                            status: AccountResponseStatus.FAILURE,
                            message: _ctx.t0.message
                        });
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    13
                ]
            ]);
        }))();
    };
    accountManager.DeleteProject = function DeleteProject(projectName) {
        var _this = this;
        return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var ref, project, _$error;
            return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return supabase.from("projects").delete().eq("owner", _this.userEmail).eq("slug", projectName);
                    case 3:
                        ref = _ctx.sent;
                        project = ref.data;
                        _$error = ref.error;
                        if (!_$error) {
                            _ctx.next = 10;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            status: AccountResponseStatus.FAILURE,
                            message: _$error.message
                        });
                    case 10:
                        return _ctx.abrupt("return", {
                            status: AccountResponseStatus.SUCCESS,
                            message: "Deleted ".concat(projectName, " successfully."),
                            data: project
                        });
                    case 11:
                        _ctx.next = 16;
                        break;
                    case 13:
                        _ctx.prev = 13;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", {
                            status: AccountResponseStatus.FAILURE,
                            message: _ctx.t0.message
                        });
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    13
                ]
            ]);
        }))();
    };
    accountManager.GetDeployments = function GetDeployments(projectSlug) {
        return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var ref, deployments, _$error, projectDeployments;
            return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return supabase.from("deployments").select("id, project_id, created_at, project:project_id(slug, current_deployment_id)").order("created_at", {
                            ascending: false
                        }).limit(100);
                    case 3:
                        ref = _ctx.sent;
                        deployments = ref.data;
                        _$error = ref.error;
                        projectDeployments = deployments.filter(function(deployment) {
                            return Array.isArray(deployment.project) ? false : deployment.project.slug === projectSlug;
                        });
                        if (!_$error) {
                            _ctx.next = 11;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            status: AccountResponseStatus.FAILURE,
                            message: _$error.message
                        });
                    case 11:
                        return _ctx.abrupt("return", {
                            status: AccountResponseStatus.SUCCESS,
                            message: "Fetched deployments successfully.",
                            data: projectDeployments
                        });
                    case 12:
                        _ctx.next = 17;
                        break;
                    case 14:
                        _ctx.prev = 14;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", {
                            status: AccountResponseStatus.FAILURE,
                            message: _ctx.t0.message
                        });
                    case 17:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    14
                ]
            ]);
        }))();
    };
    accountManager.UpdateJsonFile = function UpdateJsonFile(filePath, file) {
        return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var ref, data, _$error;
            return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return supabase.storage.from("exports").update("".concat(filePath, "?t=").concat(Date.now()), file, {
                            upsert: true,
                            contentType: "application/json",
                            cacheControl: "no-cache"
                        });
                    case 3:
                        ref = _ctx.sent;
                        data = ref.data;
                        _$error = ref.error;
                        if (!_$error) {
                            _ctx.next = 10;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            status: AccountResponseStatus.FAILURE,
                            message: _$error.message
                        });
                    case 10:
                        return _ctx.abrupt("return", {
                            status: AccountResponseStatus.SUCCESS,
                            message: "Export updated successfully.",
                            data: data
                        });
                    case 11:
                        _ctx.next = 16;
                        break;
                    case 13:
                        _ctx.prev = 13;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", {
                            status: AccountResponseStatus.FAILURE,
                            message: _ctx.t0.message
                        });
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    13
                ]
            ]);
        }))();
    };
    accountManager.CreateDeployment = function CreateDeployment(projectSlug) {
        return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var projectsResult, deploymentsInsertResult;
            return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return supabase.from("projects").select("id").eq("slug", projectSlug).single();
                    case 3:
                        projectsResult = _ctx.sent;
                        if (!projectsResult.error) {
                            _ctx.next = 6;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            status: AccountResponseStatus.FAILURE,
                            message: projectsResult.error.message
                        });
                    case 6:
                        _ctx.next = 8;
                        return supabase.from("deployments").insert({
                            project_id: projectsResult.data.id
                        }).select("id, project_id").single();
                    case 8:
                        deploymentsInsertResult = _ctx.sent;
                        if (!deploymentsInsertResult.error) {
                            _ctx.next = 11;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            status: AccountResponseStatus.FAILURE,
                            message: deploymentsInsertResult.error.message
                        });
                    case 11:
                        return _ctx.abrupt("return", {
                            status: AccountResponseStatus.SUCCESS,
                            message: "Deployment created successfully.",
                            data: deploymentsInsertResult.data
                        });
                    case 14:
                        _ctx.prev = 14;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", {
                            status: AccountResponseStatus.FAILURE,
                            message: _ctx.t0.message
                        });
                    case 17:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    14
                ]
            ]);
        }))();
    };
    accountManager.PublishDeployment = function PublishDeployment(param) {
        var deploymentId = param.deploymentId, projectId = param.projectId;
        return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var error;
            return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return supabase.from("projects").update({
                            current_deployment_id: deploymentId
                        }).eq("id", projectId);
                    case 2:
                        error = _ctx.sent.error;
                        if (!error) {
                            _ctx.next = 7;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            status: AccountResponseStatus.FAILURE,
                            message: error.message
                        });
                    case 7:
                        return _ctx.abrupt("return", {
                            status: AccountResponseStatus.SUCCESS,
                            message: "Deployment published successfully."
                        });
                    case 8:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    accountManager.UploadProject = function UploadProject(param) {
        var deploymentId = param.deploymentId, projectSlug = param.projectSlug, file = param.file;
        return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var filePathParts, filePath, fileData, ref, data, _$error;
            return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        filePathParts = file.webkitRelativePath.split("/");
                        filePath = "".concat(projectSlug, "/").concat(deploymentId, "/").concat(filePathParts.slice(1).join("/"));
                        _ctx.next = 5;
                        return file.arrayBuffer();
                    case 5:
                        fileData = _ctx.sent;
                        _ctx.next = 8;
                        return supabase.storage.from("exports").upload(filePath, fileData, {
                            upsert: true,
                            contentType: file.type
                        });
                    case 8:
                        ref = _ctx.sent;
                        data = ref.data;
                        _$error = ref.error;
                        if (!_$error) {
                            _ctx.next = 15;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            status: AccountResponseStatus.FAILURE,
                            message: _$error.message
                        });
                    case 15:
                        return _ctx.abrupt("return", {
                            status: AccountResponseStatus.SUCCESS,
                            message: "Fetched project bucket successfully.",
                            data: data
                        });
                    case 16:
                        _ctx.next = 21;
                        break;
                    case 18:
                        _ctx.prev = 18;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", {
                            status: AccountResponseStatus.FAILURE,
                            message: _ctx.t0.message
                        });
                    case 21:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    18
                ]
            ]);
        }))();
    };
    accountManager.ListFiles = function ListFiles(folderName) {
        return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var ref, contents, _$error;
            return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return supabase.storage.from("exports").list(folderName);
                    case 3:
                        ref = _ctx.sent;
                        contents = ref.data;
                        _$error = ref.error;
                        if (!_$error) {
                            _ctx.next = 10;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            status: AccountResponseStatus.FAILURE,
                            message: _$error.message
                        });
                    case 10:
                        return _ctx.abrupt("return", {
                            status: AccountResponseStatus.SUCCESS,
                            message: "Fetched project bucket successfully.",
                            data: contents
                        });
                    case 11:
                        _ctx.next = 16;
                        break;
                    case 13:
                        _ctx.prev = 13;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", {
                            status: AccountResponseStatus.FAILURE,
                            message: _ctx.t0.message
                        });
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    13
                ]
            ]);
        }))();
    };
    accountManager.DeleteFiles = function DeleteFiles(filePaths) {
        return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var ref, data, _$error;
            return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return supabase.storage.from("exports").remove(filePaths);
                    case 3:
                        ref = _ctx.sent;
                        data = ref.data;
                        _$error = ref.error;
                        if (!_$error) {
                            _ctx.next = 10;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            status: AccountResponseStatus.FAILURE,
                            message: _$error.message
                        });
                    case 10:
                        return _ctx.abrupt("return", {
                            status: AccountResponseStatus.SUCCESS,
                            message: "Successfully deleted.",
                            data: data
                        });
                    case 11:
                        _ctx.next = 16;
                        break;
                    case 13:
                        _ctx.prev = 13;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", {
                            status: AccountResponseStatus.FAILURE,
                            message: _ctx.t0.message
                        });
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    13
                ]
            ]);
        }))();
    };
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(accountManager, null, [
        {
            key: "UserEmail",
            get: function get() {
                return this.userEmail;
            }
        },
        {
            key: "UserUuid",
            get: function get() {
                return this.userUuid;
            }
        },
        {
            key: "UserName",
            get: function get() {
                return this.userName;
            }
        },
        {
            key: "UserAvatar",
            get: function get() {
                if (this.userAvatar == "") {
                    this.userAvatar = "https://via.placeholder.com/128x128";
                }
                return this.userAvatar;
            }
        }
    ]);
    return accountManager;
}();
accountManager.userEmail = "";
accountManager.userUuid = "";
accountManager.userName = "";
accountManager.userAvatar = "";
var AccountResponseStatus;
(function(AccountResponseStatus) {
    AccountResponseStatus["SUCCESS"] = "success";
    AccountResponseStatus["FAILURE"] = "failure";
})(AccountResponseStatus || (AccountResponseStatus = {}));
/* harmony default export */ __webpack_exports__["Z"] = (accountManager);


/***/ })

}]);